import {
  CubeReducerState,
  ValidationResult
} from 'modules/Cube/domain/cube.domain.types'
import {
  getBillingToday,
  hasAmendmentDatePassed
} from 'modules/Cube/domain/postActionStages/queries/hasAmendmentDatePassed'
import { DEFAULT_VALIDATION_MESSAGES } from '../messages.quote'

/**
 * Billing won't publish an amendment whose date has passed, so the editor
 * asks for a new one first rather than letting the publish fail.
 */
export const amendmentDateNotPassed = (
  prevState: Pick<CubeReducerState, 'data'>
): ValidationResult[] | null => {
  const effectiveFrom = prevState.data.quote.amendment?.effectiveFrom
  const isAmendment = prevState.data.quote.dealType === 'AMENDMENT'

  if (!isAmendment || !effectiveFrom) {
    return null
  }

  const hasPassed = hasAmendmentDatePassed({
    effectiveFrom,
    today: getBillingToday()
  })

  return hasPassed
    ? [{ message: DEFAULT_VALIDATION_MESSAGES.AMENDMENT_DATE_PASSED }]
    : null
}
